import { getInstanceId } from '@va/dashboard/selectors/app';
import { getPreviousYearGlobalFilter, getStepFilter } from '@va/dashboard/selectors/ui';
import { PeriodFilter } from '@va/types/time';
import { Moment } from 'moment';
import { useSelector } from 'react-redux';

export const usePreviousYearPeriodFilter = <T extends boolean = true>(
  keepOffset = true,
  convertToIso: T = true as T,
) => {
  const { from, until } = useSelector(getPreviousYearGlobalFilter);
  const { period: unit } = useSelector(getStepFilter);

  const websiteId = useSelector(getInstanceId);

  return {
    from: convertToIso ? from.toISOString(keepOffset) : from,
    until: convertToIso ? until.toISOString(keepOffset) : until,
    unit,
    websiteId,
  } as PeriodFilter<T extends true ? string : Moment>;
};
